import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { api } from "../services/api";

/** Certifications completed by staff in the signed-in organization. */
export const useCourseCompletions = () => {
  const { user, token } = useAuth();

  return useQuery({
    queryKey: ["courseCompletions", user?.schoolId],
    queryFn: async () => {
      if (!user?.schoolId || !token) {
        throw new Error("Missing schoolId or token");
      }
      return api.courseProgress.listCompletions(user.schoolId, token);
    },
    enabled: !!user?.schoolId && !!token,
  });
};
